import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { NotificationService } from '../services/notification.service';
import { ToastEvent } from './toast-models';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-toaster',
    templateUrl: './toaster.component.html',
    styleUrls: ['./toaster.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ToasterComponent implements OnInit, OnDestroy {
    toastEvents: ToastEvent[] = [];
    private destroy$ = new Subject<void>();

    constructor(private notificationService: NotificationService, private cdr: ChangeDetectorRef) { }

    ngOnInit() {
        this.notificationService.toastEvents
            .pipe(takeUntil(this.destroy$))
            .subscribe((toast) => {
                const currentToast: ToastEvent = {
                    type: toast.type,
                    title: toast.title,
                    message: toast.message,
            };
            this.toastEvents.push(currentToast);
            this.cdr.detectChanges();
        });
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    dispose(index: number) {
        this.toastEvents.splice(index, 1);
        this.cdr.detectChanges();
    }
}
